import React, { useEffect, useState } from 'react';
import "../../styles/home/hero-banner.css"
import { Link } from 'react-router-dom';
import { getAllHomeData } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner'

const HeroBanner = () => {
    const [loader, setLoader] = useState(true);
    const [bannerData, setBannerData] = useState([]);
    const [error, setError] = useState(null);

    // Fetch banner data
    const getBannerData = () => {
        getAllHomeData()
            .then((res) => {
                // console.log('Banner data:', res.data.home.banners);
                const bannerData = res.data.home.banners;
                setBannerData(bannerData);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setError("An error occurred while fetching the banner data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getBannerData();
    }, []);

    return (
        <main className="banner-main">
            <section className="home-slider-main">

                {loader && <LoadingSpinner />}
                {error && <div className="error">{error}</div>}

                <div className="home-slider-inner">
                    <div
                        id="carouselExample"
                        className="carousel slide"
                        data-bs-ride="carousel"
                    >
                        <div className="carousel-inner">
                            {/* Dynamically rendering carousel items based on bannerData */}
                            {bannerData.map((banner, index) => (
                                <div
                                    key={banner.id}
                                    className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                >
                                    <img
                                        src={banner.url}
                                        className="d-block w-100"
                                        alt={banner.title}
                                    />
                                    <div className="home-slider-title">
                                        <p>{banner.title}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target="#carouselExample"
                            data-bs-slide="prev"
                        >
                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target="#carouselExample"
                            data-bs-slide="next"
                        >
                            <span className="carousel-control-next-icon" aria-hidden="true" />
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>


                    <div className="welcome-sub-slider-main">
                        <div
                            id="carouselExampleIndicators3"
                            className="carousel slide"
                            data-bs-ride="carousel"
                        >
                            <div className="carousel-indicators">
                                <button
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators3"
                                    data-bs-slide-to={0}
                                    className="active"
                                    aria-current="true"
                                    aria-label="Slide 1"
                                />
                                <button
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators3"
                                    data-bs-slide-to={1}
                                    aria-label="Slide 2"
                                />
                                <button
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators3"
                                    data-bs-slide-to={2}
                                    aria-label="Slide 3"
                                />
                                <button
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators3"
                                    data-bs-slide-to={3}
                                    aria-label="Slide 4"
                                />
                            </div>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="carousel-item-inner">
                                        <div className="item-image">
                                            <img src="../../assets/images/ccsu-logo-half.svg" alt="" />
                                        </div>
                                        <div>
                                            <h6 className="text-uppercase">CCSU Rankings</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="carousel-item-inner">
                                        <div className="item-image">
                                            <img
                                                src="../../assets/images/circle-category/naac-logo.png"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <h6>NAAC</h6>
                                            <p>'A++'-Grade</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="carousel-item-inner">
                                        <div className="item-image">
                                            <img
                                                src="../../assets/images/circle-category/ranking1.png"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <h6>#701-750</h6>
                                            <p>in QS Asia University Rankings | 2024</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="carousel-item-inner">
                                        <div className="item-image">
                                            <img
                                                src="../../assets/images/circle-category/ranking1.png"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <h6>#219</h6>
                                            <p>in QS Asia University Rankings 2024: Southern Asia</p>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    className="carousel-control-prev"
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators"
                                    data-bs-slide="prev"
                                >
                                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button
                                    className="carousel-control-next"
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators"
                                    data-bs-slide="next"
                                >
                                    <span className="carousel-control-next-icon" aria-hidden="true" />
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="home-slider-profile">
                <div className="boxes">
                    <div className="box">
                        <div className="box-inner">
                            <div className="d-flex justify-content-center">
                                <img
                                    src="../../assets/images/ccs-1-22.jpg"
                                    alt="chaudhary charan singh"
                                />
                            </div>
                            <div className="middle">
                                <h6>Hon'ble Chaudhary Charan Singh Ji</h6>
                                <p>Bharat Ratna &amp; Former Prime Minister</p>
                                <div className="d-flex justify-content-center">
                                    <Link
                                        to={"/chaudhary-charan-singh"}
                                        className="normal-button"
                                        style={{
                                            padding: 5,
                                            fontSize: "13px !important",
                                            backgroundColor: "#f0f6fd"
                                        }}
                                    >
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-inner">
                            <div className="d-flex justify-content-center">
                                <img src="../../assets/images/chancellor.png" alt="" />
                            </div>
                            <div className="middle">
                                <h6>Smt. Anandiben Patel</h6>
                                <p>Hon'ble Chancellor</p>
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                    <Link
                                        to={"/chancellor"}
                                        className="normal-button"
                                        style={{
                                            padding: 5,
                                            fontSize: "13px !important",
                                            backgroundColor: "#f0f6fd"
                                        }}
                                    >
                                        Profile
                                    </Link>
                                    {/* <Link to={"/chancellor-message"} className="normal-button"
          style="padding:5px; font-size:13px !important; background-color: #f0f6fd;">Message</Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-inner">
                            <div className="d-flex justify-content-center">
                                <img src="../../assets/images/vc-img.jpg" alt="vc" />
                            </div>
                            <div className="middle">
                                <h6>Prof. Sangeeta Shukla</h6>
                                <p>Hon'ble Vice-Chancellor</p>
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                    <Link
                                        to={"/vice-chancellor"}
                                        className="normal-button"
                                        style={{
                                            padding: 5,
                                            fontSize: "13px !important",
                                            backgroundColor: "#f0f6fd"
                                        }}
                                    >
                                        Profile
                                    </Link>
                                    <Link
                                        to={"/vice-chancellor-message"}
                                        className="normal-button"
                                        style={{
                                            padding: 5,
                                            fontSize: "13px !important",
                                            backgroundColor: "#f0f6fd"
                                        }}
                                    >
                                        Message
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

    )
}

export default HeroBanner;